module.exports = "<router-outlet></router-outlet>\n<simple-notifications [options]=\"options\"></simple-notifications>"